export function removeUndefinedFields<T extends object>(obj: T): Partial<T> {
  Object.keys(obj).forEach((key) => {
    if (obj[key as keyof T] === undefined) {
      delete obj[key as keyof T];
    }
  });
  return obj;
}
